export default Object.freeze({
  Unset: 0,
  WorkSkills: 1,
  SensorySkills: 2,
  CognitiveSkills: 3,
  ReadingSkills: 4,
  MathematicsSkills: 5,
  MotorSkills: 6,
  WritingSkills: 7,
  CommunicationSkills: 8,
  SelfCareSkills: 9,
  DailyLivingSkills: 10,
  Interests: 11,
})
